//import liraries
import React, { Component } from "react";
import { View, Text, StyleSheet } from "react-native";
import CText from "../../../common/CText";

// create a component
const TiDisputeCountCard = (props) => {
  const disputeData = props.disputeData;

  return (
    <View style={styles.container}>
      <View style={{ alignItems: "center" }}>
        <CText.disputeCountText style={{ fontSize: 30 }}>
          {disputeData && disputeData?.getDisputeCounts
            ? (disputeData?.getDisputeCounts?.raised < 10 ? `0${disputeData?.getDisputeCounts?.raised}` : disputeData?.getDisputeCounts?.raised)
            : "00"}
        </CText.disputeCountText>
        <CText.disputeCountText>{"Raised"}</CText.disputeCountText>
      </View>
      <View
        style={{
          width: 1,
          height: 48,
          opacity: 0.6,
          backgroundColor: "#ccd0d5",
        }}
      />
      <View style={{ alignItems: "center" }}>
        <CText.disputeCountText style={{ fontSize: 30, color: "#ff9006" }}>
        {disputeData && disputeData?.getDisputeCounts
            ? (disputeData?.getDisputeCounts?.inProgress < 10 ? `0${disputeData?.getDisputeCounts?.inProgress}` : disputeData?.getDisputeCounts?.inProgress)
            : "00"}
        </CText.disputeCountText>
        <CText.disputeCountText style={{ color: "#ff9006" }}>
          {"In Progress"}
        </CText.disputeCountText>
      </View>
      <View
        style={{
          width: 1,
          height: 48,
          opacity: 0.6,
          backgroundColor: "#ccd0d5",
        }}
      />
      <View style={{ alignItems: "center" }}>
        <CText.disputeCountText style={{ fontSize: 30, color: "#43b32e" }}>
        {disputeData && disputeData?.getDisputeCounts
            ? (disputeData?.getDisputeCounts?.closed < 10 ? `0${disputeData?.getDisputeCounts?.closed}` : disputeData?.getDisputeCounts?.closed)
            : "00"}
        </CText.disputeCountText>
        <CText.disputeCountText style={{ color: "#43b32e" }}>
          {"Closed"}
        </CText.disputeCountText>
      </View>
    </View>
  );
};

// define your styles
const styles = StyleSheet.create({
  container: {
    width: 300,
    height: 86,
    borderRadius: 10,
    backgroundColor: "#ffffff",
    shadowColor: "rgba(176, 176, 176, 0.2)",
    shadowOffset: {
      width: 0,
      height: 11,
    },
    shadowRadius: 17,
    shadowOpacity: 1,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#ccd0d5",
    alignItems: "center",
    justifyContent: "space-around",
    flexDirection: "row",
  },
});

//make this component available to the app
export default TiDisputeCountCard;
